// public/llms-full.txt restates this FAQ in plain text for crawlers: keep it in sync when editing the copy here.
export default function Faq() {
	return (
		<div className="space-y-6">
			<h1 className="scroll-m-20 text-4xl font-bold tracking-tight">Frequently Asked Questions</h1>
    
			<h2 className="scroll-m-20 border-b pb-2 text-2xl font-semibold tracking-tight">
				What is hangaround.live?
			</h2>
			<p>
				hangaround.live is a platform designed to help you find those people who live around you and you'd like to know, 
				but you never happened to meet. 
				Based on what you share with us about your interests, we'll create small private discussion groups for you. 
				They are intentionally small (5-10 people) so everyone can be heard, made up of people who live near each other, 
				focusing on a topic they all share an interest in. 
			</p>

			<h2 className="scroll-m-20 border-b pb-2 text-2xl font-semibold tracking-tight">
				How does it work?
			</h2>
			<ol className="list-decimal list-inside space-y-2">
				<li>Share your interests, hobbies, goals, and what kind of people you'd like to meet, either in your introduction during signup, or in a chat with ChumBot.</li>
				<li>We add you to private discussion groups of 5-10 people in your area. Each group is focused on a topic you all expressed an interest in.</li>
				<li>It's a topic you have something to say about; it's people who want to hear about it; and it's a small enough group that your words won't be lost in the noise.</li>
				<li>Hopefully some of you will find each other interesting enough to meet up in real life too!</li>
			</ol>

			<h2 className="scroll-m-20 border-b pb-2 text-2xl font-semibold tracking-tight">
				How is it different from social networks or friend-finder apps?
			</h2>
			<ul className="list-disc list-inside space-y-2">
				<li>
					<strong>Quality over Quantity: </strong> 
					Unlike large, noisy online forums, hangaround.live curates small, focused discussion groups 
					with members selected for compatibility based on shared interests.
				</li>
				<li>
					<strong>Proximity Matters: </strong> 
					Social networks often fail to connect you with people nearby. 
					hangaround.live considers your location, making it easier for online discussions to transition to real-life meetups.
				</li>
				<li>
					<strong>Flexible Matching: </strong> 
					Traditional friend-finder apps may force you to build a profile out of predefined categories, checkboxes and lists. 
					Here you can just have a chat with our bot, ChumBot, and describe yourself in your own words.
				</li>
				<li>
					<strong>Pre-selected Groups: </strong> 
					You don't need to evaluate user profiles one by one, we offer pre-selected groups. 
				</li>
				<li>
					<strong>Conversation Starters: </strong> 
					To help you get started, ChumBot suggests initial discussion topics or activities for new groups.
				</li>
			</ul>

			<h2 className="scroll-m-20 border-b pb-2 text-2xl font-semibold tracking-tight">
				Is it free?
			</h2>
			<p>
				Yes, but users with a subscription are given preference when forming groups.
				Free users keep getting added to new groups too, but less frequently.
			</p>
			<p>
				Things may change in the future, we're working on finding the best way to pay the bills of running the service.
			</p>

			{/* <h2 className="scroll-m-20 border-b pb-2 text-2xl font-semibold tracking-tight">
				How do I know what the bot has learned about me?
			</h2>
			<p>
				Simply ask ChumBot, e.g., "Tell me what you know about me."
			</p> */}

			<h2 className="scroll-m-20 border-b pb-2 text-2xl font-semibold tracking-tight">
				Can I request a group around a specific topic?
			</h2>
			<p>
				Not directly at the moment. However, if you express your interest in a topic, 
				(either by talking to ChumBot, or by updating your profile in the Settings), 
				you may get added to a group around that topic in the future.
			</p>

			<h2 className="scroll-m-20 border-b pb-2 text-2xl font-semibold tracking-tight">
				I've shared my interests but haven't been invited to any groups. Why?
			</h2>
			<p>This could be due to several reasons:</p>
			<ul className="list-disc list-inside">
				<li>If you're new, please allow a few hours for processing.</li>
				<li>
					Check if ChumBot is aware of your location (only your general area, not an exact address),
					as groups are based on proximity.
					You can check this by asking ChumBot, e.g., "Where do you think I live?"
				</li>
				<li>It's possible that there aren't enough users in your area yet. Help us grow by spreading the word!</li>
			</ul>

			<h2 className="scroll-m-20 border-b pb-2 text-2xl font-semibold tracking-tight">
				The bot keeps adding me to groups in the wrong location. What should I do?
			</h2>
			<p>
				Check if ChumBot has the correct location by asking, e.g., "Where do you think I live?" 
				If it's incorrect or unknown, just update it with your approximate area.
				You can do so either by asking ChumBot, or by updating your profile in the Settings.
			</p>

			<h2 className="scroll-m-20 border-b pb-2 text-2xl font-semibold tracking-tight">
				Can I leave a group?
			</h2>
			<p>
				Yes, you can leave a group by clicking the "Leave Group" button in the group details sidebar.
			</p>

			<h2 className="scroll-m-20 border-b pb-2 text-2xl font-semibold tracking-tight">
				What should I do if a group member is offensive or inappropriate?
			</h2>
			<p>
				You can vote for any group member to be removed from the group. 
				If a majority of the group members vote to do so, the offending member will be removed.
			</p>
		</div>
	)
}
